import Cookies from 'js-cookie';

import { TokenInfo } from '@/types/interface';
import { cookieConfig, KEY_MYGPT_REFRESH_TOKEN, KEY_MYGPT_TOKEN, KEY_MYGPT_TOKEN_EXPIRESIN } from '@mygpt/app';

// 删除URL中的参数，但不刷新当前页面。
// 如果用户下次刷新页面，被删除的参数不会出现。
export const removeSearchParam = (key: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(key);
  const newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;

  window.history.pushState(null, document.title, newURL);
};

export const saveTokenInfo = (data: TokenInfo) => {
  const { access_token, expires_in, refresh_token, token_type } = data;

  // 设置请求头需要的token
  if (access_token && token_type) {
    const token = `${token_type} ${access_token}`;
    // localStorage.setItem(KEY_MYGPT_TOKEN, token);
    Cookies.set(KEY_MYGPT_TOKEN(), token, {
      domain: cookieConfig.COOKIE_DOMAIN,
      secure: location.protocol === 'https:',
      sameSite: 'lax',
    });
  }

  // 设置refresh token
  if (refresh_token) {
    // localStorage.setItem(KEY_MYGPT_REFRESH_TOKEN, refresh_token);
    Cookies.set(KEY_MYGPT_REFRESH_TOKEN(), refresh_token, {
      domain: cookieConfig.COOKIE_DOMAIN,
      secure: location.protocol === 'https:',
      sameSite: 'lax',
    });
  }

  // 设置token过期时间
  if (expires_in) {
    const now = new Date().getTime();
    const expiresTime = JSON.stringify(now + expires_in * 1000);
    // localStorage.setItem(KEY_MYGPT_TOKEN_EXPIRESIN, expiresTime);
    Cookies.set(KEY_MYGPT_TOKEN_EXPIRESIN(), expiresTime, {
      domain: cookieConfig.COOKIE_DOMAIN,
      secure: location.protocol === 'https:',
      sameSite: 'lax',
    });
  }
};

export const isUserLoggedIn = () => {
  const token = Cookies.get(KEY_MYGPT_TOKEN());
  const tokenExpires = Cookies.get(KEY_MYGPT_TOKEN_EXPIRESIN());

  if (!token) return false;

  if (tokenExpires) {
    const nowTime = new Date().getTime();
    const expiresTime = Number(tokenExpires);
    return expiresTime > nowTime;
  }

  return false;
};
